import {
  parseDate
} from "./chunk-KPPABCK2.mjs";

// src/date/compare.ts
var isAfter = (date1, date2) => {
  return date1 > date2;
};
var isBefore = (date1, date2) => {
  return date1 < date2;
};
var isSameDay = (firstDate, secondDate) => {
  const first = typeof firstDate === "string" ? parseDate(firstDate) : firstDate;
  const second = typeof secondDate === "string" ? parseDate(secondDate) : secondDate;
  return first.getFullYear() === second.getFullYear() && first.getMonth() === second.getMonth() && first.getDate() === second.getDate();
};
var isSameDayFromMilli = (firstDate, secondDate) => {
  const first = new Date(firstDate * 1e3);
  const second = new Date(secondDate * 1e3);
  return first.getFullYear() === second.getFullYear() && first.getMonth() === second.getMonth() && first.getDate() === second.getDate();
};
var isSameMonth = (firstDate, secondDate) => {
  const first = typeof firstDate === "string" ? parseDate(firstDate) : firstDate;
  const second = typeof secondDate === "string" ? parseDate(secondDate) : secondDate;
  return first.getFullYear() === second.getFullYear() && first.getMonth() === second.getMonth();
};
var isSameMonthFromMilli = (firstDate, secondDate) => {
  const first = new Date(firstDate * 1e3);
  const second = new Date(secondDate * 1e3);
  return first.getFullYear() === second.getFullYear() && first.getMonth() === second.getMonth();
};
var isSameYear = (firstDate, secondDate) => {
  const first = typeof firstDate === "string" ? parseDate(firstDate) : firstDate;
  const second = typeof secondDate === "string" ? parseDate(secondDate) : secondDate;
  return first.getFullYear() === second.getFullYear();
};
var isSameYearFromMilli = (firstDate, secondDate) => {
  const first = new Date(firstDate * 1e3);
  const second = new Date(secondDate * 1e3);
  return first.getFullYear() === second.getFullYear();
};
var isWeekened = (date) => {
  const d = typeof date === "string" ? parseDate(date) : date;
  const day = d.getDay();
  return day === 5 || day === 6;
};
var isEqual = (firstDate, secondDate) => {
  const d1 = typeof firstDate === "string" ? parseDate(firstDate) : firstDate;
  const d2 = typeof secondDate === "string" ? parseDate(secondDate) : secondDate;
  return d1.getTime() === d2.getTime();
};

export {
  isAfter,
  isBefore,
  isSameDay,
  isSameDayFromMilli,
  isSameMonth,
  isSameMonthFromMilli,
  isSameYear,
  isSameYearFromMilli,
  isWeekened,
  isEqual
};
//# sourceMappingURL=chunk-ZJNPIW4V.mjs.map